import { CogRefreshOutlineIcon } from './CogRefreshOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C9E15196-FEB0-4F26-96C2-0E050F959806
 * name cog-refresh-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-refresh-outline.svg
 * tags
 * - Settings 
 */
export const SettingsRefreshOutlineIcon = CogRefreshOutlineIcon;
export default SettingsRefreshOutlineIcon